import axios from 'axios'
import HttpHelper from '@/utils/HttpHelper'

// const devURL = 'https://sasuke.dd.com/apps-manager/api/v1/';
// const devURL = 'https://naruto.dd.com/apps-manager/api/v1/';
const devURL = 'https://deliverydireto.com.br/apps-manager/api/v1/'

const prodURL = process.env.VUE_APP_API_URL ?? 'https://deliverydireto.com.br/apps-manager/api/v1/'
const baseURL = process.env.NODE_ENV === 'production' ? prodURL : devURL

const http = axios.create({
    baseURL,
})

http.interceptors.request.use(HttpHelper.interceptor, HttpHelper.errorInterceptor)

export default http
